module.exports = __webpack_public_path__ + "Alma-1aec4716.png";